import request from '@/utils/request'

export function updateCfgByLevel(data) {
  return request({
    url: 'api/v1/sys-cfg/updateCfgByLevel',
    method: 'post',
    data: data
  })
}

export function getCfgByLevel() {
  return request({
    url: 'api/v1/sys-cfg/getCfgByLevel',
    method: 'get'
  })
}

export function getBasicCfg(data) {
  return request({
    url: 'api/v1/sys-cfg/getBasicCfg',
    method: 'post',
    data: data
  })
}

export function updateCdn(data) {
  return request({
    url: 'api/v1/sys-cfg/uploadCdn',
    method: 'post',
    data: data
  })
}
export function updateBasicCfg(data) {
  return request({
    url: 'api/v1/sys-cfg/updateBasicCfg',
    method: 'post',
    data: data
  })
}
export function delBasicCfg(data) {
  return request({
    url: 'api/v1/sys-cfg/delBasicCfg',
    method: 'delete',
    data: data
  })
}

export function getCoinDozerCfg() {
  return request({
    url: 'api/v1/sys-cfg/getCoinDozerCfg',
    method: 'get'
  })
}

export function getSysCfg(data) {
  return request({
    url: 'api/v1/sys-cfg/getSysCfg',
    method: 'post',
    data: data
  })
}

export function exportJson(data) {
  return request({
    url: 'api/v1/sys-cfg/exportJson',
    method: 'get',
    data: data
  })
}

export function updateCoinDozerCfg(data) {
  return request({
    url: 'api/v1/sys-cfg/updateDozerCfg',
    method: 'post',
    data: data
  })
}
